import React, { useEffect, useState } from 'react';
import { getPreNeedViewerInfo } from '~/api/NewViewer';
import { getCountry } from 'react-international-phone';
import { useFingerPrint } from '~/components/FingerPrintProvider';
export function useContatCaptureForm(eventId) {
    const [loading, setLoading] = useState(true);
    const { country, fingerprint } = process.env.NODE_ENV === 'test'
        ? {
            country: 'NZ',
            fingerprint: 'mockFingerPrint',
        }
        : useFingerPrint();
    const [selectedCountry, setSelectedCountry] = React.useState(getCountry({ field: 'iso2', value: country ? country.toLowerCase() : 'us' }));
    const [contactData, setContactData] = useState({
        fullName: '',
        oldEmail: '',
        email: '',
        country,
        mobile: '',
        zip: '',
        tandc: false,
    });
    const IS_USA = selectedCountry?.iso2.toUpperCase() === 'US';
    useEffect(() => {
        const verifyContactInfo = async () => {
            const verifyResponse = await getPreNeedViewerInfo(eventId, fingerprint);
            const _country = getCountry({ field: 'name', value: verifyResponse.country });
            const _phone = verifyResponse.phone?.replace(_country?.dialCode, '');
            setSelectedCountry(_country);
            setContactData({
                fullName: verifyResponse.name,
                oldEmail: verifyResponse.email,
                email: verifyResponse.preferredEmail !== '' ? verifyResponse.preferredEmail : verifyResponse.email,
                country: _country?.iso2 ?? 'us',
                mobile: _phone,
                zip: verifyResponse.postcode,
                tandc: false,
            });
            setLoading(false);
        };
        verifyContactInfo();
    }, []);
    return {
        loading,
        setLoading,
        selectedCountry,
        setSelectedCountry,
        IS_USA,
        contactData
    };
}
